/**
 * A2UI Column Component
 * Vertical flex container for children
 */

import React from 'react';

const alignmentMap = {
  'start': 'flex-start',
  'center': 'center',
  'end': 'flex-end',
  'stretch': 'stretch',
};

const justifyMap = {
  'start': 'flex-start',
  'center': 'center',
  'end': 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly',
};

const A2UIColumn = ({ 
  children,
  alignment = 'stretch',
  mainAxisAlignment = 'start',
  gap = 8,
  style,
  renderChildren,
  surfaceId
}) => {
  const columnStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: alignmentMap[alignment] || 'stretch',
    justifyContent: justifyMap[mainAxisAlignment] || 'flex-start',
    gap: `${gap}px`,
    ...style
  };

  return (
    <div className="a2ui-column" style={columnStyle}>
      {renderChildren ? renderChildren(children) : null}
    </div>
  );
};

export default A2UIColumn;
